import { visibleObserver } from 'shared/utils/visibleObserver';
import debug from 'shared/utils/debug';
import VideoHLS from './video/videoHLS';
import VideoIMA from './video/videoIMA';
import { categorizeVideoType, collectVideoData } from './videoUtils';
const classMap = {
    HLS: VideoHLS,
    'VAST/VPAID': VideoIMA,
};
export class VideoManager {
    constructor() {
        this.videos = [];
        this.isReady = false;
    }
    /**
     * Setup all videos from the ad config
     */
    setup(ad, layoutId) {
        const videoConfigs = collectVideoData(ad, layoutId);
        const videoSetups = videoConfigs.map(config => {
            const { videoUrl } = config;
            const videoType = categorizeVideoType(videoUrl);
            const VideoClass = classMap[videoType];
            const video = new VideoClass(config);
            return video.setup();
        });
        // @ts-ignore TODO: Dependency updates cleanup
        return Promise.all(videoSetups).then(videos => {
            this.videos = this.videos.concat(videos);
            this.readyCallback && this.readyCallback.call(null, this);
            // log that video load are ready
            this.isReady = true;
            visibleObserver(visible => {
                visible ? this.resumeVideos() : this.pauseVideos();
            });
            return videos;
        });
    }
    /**
     * Store user-defined onReady callback
     */
    onReady(readyCallback) {
        // only allow one ready callback
        if (this.readyCallback) {
            return;
        }
        // assign ready callback for above `setup` call
        this.readyCallback = readyCallback;
        // in case `setup` goes too fast before this assignment
        // execute the callback
        if (this.isReady && this.readyCallback) {
            this.readyCallback(this);
        }
    }
    /**
     * Get video by symbol id
     * return the first video if symbolId is not defined
     */
    getVideo(symbolId) {
        const video = symbolId
            ? this.videos.find(vid => vid.config.symbolId === symbolId)
            : this.videos[0];
        if (!video) {
            debug('Cannot get video', symbolId);
        }
        return video;
    }
    /**
     * mass control playback for all videos
     * pause all videos without tracking
     */
    pauseVideos() {
        this.videos.forEach(video => video.isPlaying() && video.pause(false));
    }
    /**
     * mass control playback for all videos
     * play all videos and keeps tracking playing progress
     */
    resumeVideos() {
        this.videos.forEach(video => {
            // can only resume video that has already initially started
            const canPlay = video.videoStarted && !video.isPlaying();
            if (canPlay) {
                video.play();
            }
        });
    }
}
export default VideoManager;
